<template>
    <layout>
        <article class="news news--single">
            <div class="container-fluid pb-3 pt-3">
                <header class="news__header">
                    <h1 class="news__title">{{page.title}}</h1>
                </header>
                <div class="news__content" v-html="page.content" />
            </div>
        </article>
    </layout>
</template>
<script>
    import mixin from '../mixin';
    import layout from '../layouts/Main.vue';
    import { formatString } from '@config/utils';

    export default {
        name: 'Page',
        mixins: [
            mixin
        ],
        components: { layout },
        props: {
            slug: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                pageID: 'pages',
                page: { },
            }
        },
        methods: {
            loadPage() {
                const params = { slug: this.slug };
                const url = formatString(this.url.getSingle, params);

                this.$http(url).then(({data}) => {
                    this.page = data.data;
                    let title = this.page.title;
                    this.$store.dispatch('breadcrumbChanged', {label: title});
                }).catch((err) => {
                    console.error(err);
                    this.$router.push({name: 'portal.home'});
                });
            }
        },
        mounted() {
            this.loadPage();
        },
        beforeRouteLeave: function(to, from, next) {
            this.$store.dispatch('breadcrumbChanged', {label: from.meta.defaultTitle});
            next();
        }
    }
</script>
